import { PayloadAction } from '@reduxjs/toolkit'
import { Currency, CurrencySliceType } from 'src/core/models'
import { initialState } from './state'

const reducers = {
  /* Company List Reducers */
  setCurrencyListLoading: (state: CurrencySliceType, action: PayloadAction<boolean>) => {
    state.list.loading = action.payload
  },
  setCurrencyListData: (state: CurrencySliceType, action: PayloadAction<Currency[]>) => {
    state.list.data = action.payload
  },
  resetCurrencyListState: (state: CurrencySliceType) => {
    state.list = initialState.list
  },
}

export default reducers
